import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as sections from '../../sections'

@ngCore.Component({
  imports: [
    ds.layout.stepper.Component,
    ds.layout.stepper.child.item.Component,
    ds.layout.page.Component,
    sections.header.Component,
    sections.grid.Component,
  ],
  selector: 'atn-mosaic-scrolling-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )
}
